import { render, staticRenderFns } from "./ItemEdit_Dispatches_List.vue?vue&type=template&id=1f58c0b2&"
import script from "./ItemEdit_Dispatches_List.vue?vue&type=script&lang=js&"
export * from "./ItemEdit_Dispatches_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports